import React from "react";
import Alert from "@mui/material/Alert";

const formatWeight = value =>
  `${Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} lbs`;

export function hasShipmentWeightMismatch(shipment) {
  const entered = Number(shipment?.totalWeight || 0);
  const calculated = Number(shipment?.calculatedTotalWeight || 0);

  return entered > 0 && calculated > 0 && Math.abs(entered - calculated) > 1;
}

export default function WeightMismatchAlert({ shipment }) {
  if (!hasShipmentWeightMismatch(shipment)) {
    return null;
  }

  const entered = Number(shipment.totalWeight);
  const calculated = Number(shipment.calculatedTotalWeight);
  const difference = Math.abs(entered - calculated);

  return (
    <Alert severity="warning" sx={{ mx: 2, mt: 1 }}>
      Inbound total weight is {formatWeight(entered)}, but the item weights add up to{" "}
      {formatWeight(calculated)}. Difference: {formatWeight(difference)}.
    </Alert>
  );
}
